import type { Image } from "types/image";

export function getHighestResolutionImageSource(
  image: Image | null | undefined,
): Image["sources"][number] | null {
  return (
    image?.sources.reduce((max, source) =>
      source.width > max.width ? source : max,
    ) || null
  );
}

export function getLowestResolutionImageSource(
  image: Image | null | undefined,
): Image["sources"][number] | null {
  return (
    image?.sources.reduce((min, source) =>
      source.width < min.width ? source : min,
    ) || null
  );
}
